export const vi = {
    translation: {
        b: {
            cancel: 'Hủy',
            confirm: 'Xác nhận',
            send: 'Gửi',
            done: 'Hoàn tất',
            close: 'Đóng',
            clear: 'Xóa',
            copy_link: 'Sao chép liên kết',
            export: 'Xuất',
            delete: 'Xóa',
            delete_confirm: 'Xác nhận xóa',
            duplicate: 'Nhân bản',
            share: 'Chia sẻ',
            sign_in: 'Đăng nhập',
            sign_up: 'Đăng ký',
            email_address: 'Địa chỉ email',
            yes: 'Có',
            no: 'Không'
        },
        m_languages: {
            title: 'Ngôn ngữ',
            subtitle: 'Chọn ngôn ngữ'
        },
        m_feedback: {
            feature: {
                name: 'Yêu cầu tính năng',
                desc: 'Thiếu tính năng bạn cần? Hãy cho chúng tôi biết — ý tưởng của bạn rất quan trọng'
            },
            feedback: {
                name: 'Phản hồi',
                desc: 'Phản hồi của bạn rất quan trọng đối với chúng tôi — hãy để lại một ghi chú ngắn'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Cảm ơn bạn về đề xuất!',
                desc: 'Chúng tôi rất trân trọng thời gian bạn chia sẻ ý kiến — điều đó giúp chúng tôi cải thiện.'
            },
            feedback: {
                name: 'Cảm ơn bạn về phản hồi!',
                desc: 'Chúng tôi rất trân trọng thời gian bạn chia sẻ ý kiến — điều đó giúp chúng tôi cải thiện.'
            }
        },
        m_diagram_details: {
            name_place: 'Nhập tên dự án',
            desc_place: 'Nhập mô tả dự án'
        },
        m_quick_share: {
            title: 'Chia sẻ nhanh',
            subtitle: '(Qua liên kết)'
        },
        m_export_img: {
            title: 'Xuất hình ảnh'
        },
        m_export_code: {
            title: 'Xuất mã {{db_engine}}',
            download_file: 'Tải xuống tệp',
            copy_code: 'Sao chép mã'
        },
        m_sign_in_remind: {
            title: 'Cảm ơn bạn đã dùng thử DB Design',
            subtitle: 'Đăng nhập hoặc đăng ký để tăng số lượng bảng tối đa, lưu sơ đồ và mở khóa thêm tính năng.'
        },
        m_sign_in_restrict: {
            title: 'Đăng nhập để làm được nhiều hơn trong ứng dụng',
            subtitle: 'Đăng nhập hoặc đăng ký để tăng giới hạn bảng, lưu sơ đồ và mở khóa thêm tính năng.'
        },
        m_new_diagram: {
            title: 'Sơ đồ mới',
            subtitle: 'Chọn công cụ cơ sở dữ liệu',
            open_diagram: 'Mở sơ đồ'
        },
        m_keyboard_shortcuts: {
            title: 'Phím tắt',
            ctrl_left: {
                title1: 'Điều khiển',
                title2: '(Trái)',
                items: {
                    mouse_sel: 'Chọn bằng chuột / Chế độ bàn tay',
                    table: 'Bảng',
                    line: 'Đường',
                    area: 'Khu vực',
                    note: 'Ghi chú',
                    comment: 'Bình luận',
                    pen: 'Bút',
                    undo: 'Hoàn tác',
                    redo: 'Làm lại'
                }
            },
            ctrl_top_left: {
                title1: 'Điều khiển',
                title2: '(Trên trái)',
                items: {
                    export_img: 'Xuất hình ảnh',
                    search: 'Tìm kiếm',
                    editor_panel: 'Bảng trình soạn thảo'
                }
            },
            ctrl_bottom_right: {
                title1: 'Điều khiển',
                title2: '(Dưới phải)',
                items: {
                    minimap: 'Bản đồ thu nhỏ',
                    zoom_in: 'Phóng to',
                    zoom_out: 'Thu nhỏ',
                    zoom_100: 'Zoom 100%'
                }
            },
            ctx_tab: {
                title1: 'Menu ngữ cảnh',
                title2: '(Bảng)',
                items: {
                    dupl_tab: 'Nhân bản bảng',
                    del_tab: 'Xóa bảng'
                }
            },
            ctx_del_tab: {
                title1: 'Menu ngữ cảnh',
                title2: '(Xóa bảng)',
                items: {
                    yes: 'Có',
                    no: 'Không'
                }
            },
            ctx_tab_col: {
                title1: 'Menu ngữ cảnh',
                title2: '(Cột của bảng)',
                items: {
                    add_col_below: 'Thêm cột bên dưới',
                    focus_col_above: 'Di chuyển tiêu điểm đến cột phía trên',
                    focus_col_below: 'Di chuyển tiêu điểm đến cột phía dưới',
                    move_col_up: 'Di chuyển cột lên',
                    move_col_down: 'Di chuyển cột xuống',
                    dupl_col: 'Nhân bản cột',
                    del_col: 'Xóa cột'
                }
            },
            ctx_line: {
                title1: 'Menu ngữ cảnh',
                title2: '(Đường)',
                items: {
                    del_line: 'Xóa đường'
                }
            },
            ctx_area: {
                title1: 'Menu ngữ cảnh',
                title2: '(Khu vực)',
                items: {
                    dupl_area: 'Nhân bản khu vực',
                    del_area: 'Xóa khu vực'
                }
            },
            ctx_multi: {
                title1: 'Menu ngữ cảnh',
                title2: '(Chọn nhiều)',
                items: {
                    select_all: 'Chọn tất cả phần tử',
                    create_area_for_select_els: 'Tạo khu vực cho các phần tử đã chọn',
                    dupl_select_els: 'Nhân bản các phần tử đã chọn',
                    del_select_els: 'Xóa các phần tử đã chọn'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Chọn bằng chuột',
                table: 'Bảng',
                line: 'Đường',
                area: 'Khu vực',
                note: 'Ghi chú (sắp ra mắt)',
                comment: 'Bình luận (sắp ra mắt)',
                pen: 'Bút',
                undo: 'Hoàn tác',
                redo: 'Làm lại'
            },
            ctrl_top_left: {
                logo: 'Lưu ý: khu vực thử nghiệm',
                name: 'Thông tin sơ đồ',
                editor: 'Trình soạn thảo (sắp ra mắt)',
                search: 'Tìm kiếm (sắp ra mắt)',
                export: 'Tùy chọn xuất',
                view_mode: 'Chế độ xem',
                zoom_to_fit: 'Vừa màn hình'
            },
            ctrl_top_right: {
                feature_req: 'Yêu cầu tính năng',
                sign_in: 'Đăng nhập',
                quick_share: 'Chia sẻ nhanh'
            },
            ctrl_bottom_right: {
                full_screen: 'Toàn màn hình',
                minimap: 'Bản đồ thu nhỏ',
                zoom_out: 'Thu nhỏ',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Phóng to',
                info: 'Thông tin & tài nguyên'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Mặc định',
                        blue: 'Xanh dương',
                        green: 'Xanh lục',
                        red: 'Đỏ',
                        purple: 'Tím',
                        violet: 'Tím violet'
                    },
                    borders: {
                        none: 'Không',
                        solid: 'Liền',
                        dashed: 'Gạch đứt',
                        dotted: 'Chấm'
                    },
                    color: 'Màu',
                    border: 'Viền',
                    description: 'Mô tả',
                    description_table_place: 'Mô tả bảng',
                    description_column_place: 'Mô tả cột',
                    description_line_place: 'Mô tả đường',
                    description_note_place: 'Mô tả ghi chú',
                    description_area_place: 'Mô tả khu vực',
                    description_pen_place: 'Mô tả bút',
                    hide_menu: 'Ẩn menu',
                    show_menu: 'Hiện menu'
                },
                tab_col: {
                    add_col_below: 'Thêm cột bên dưới',
                    add_col_above: 'Thêm cột bên trên',
                    key: 'Key',
                    keys: {
                        none: 'Không',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Không',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Di chuyển cột xuống',
                    move_col_up: 'Di chuyển cột lên',
                    more_functions: 'Thêm chức năng'
                },
                line: {
                    change_connects: 'Thay đổi đầu nối',
                    connects: {
                        empty: 'Trống',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: 'Lọc phần tử'
                },
                multi: {
                    filter: 'Lọc lựa chọn',
                    create_area: 'Tạo khu vực'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Đầy đủ',
            keys_only: 'Chỉ khóa',
            names_only: 'Chỉ tên'
        },
        dropdown_ctrl_export: {
            export_img: 'Xuất hình ảnh',
            export_code: 'Xuất mã SQL'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Đăng nhập',
            new_project: 'Dự án mới',
            keyboard_shortcuts: 'Phím tắt',
            languages: 'Ngôn ngữ'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Phản hồi',
            keyboard_shortcuts: 'Phím tắt',
            languages: 'Ngôn ngữ',
            homepage: 'Trang chủ'
        },
        n: {
            default: 'Đang tải…',
            file_ready_to_download: 'Tệp đã sẵn sàng để tải xuống',
            code_copied: 'Mã đã được sao chép',
            link_copied: 'Liên kết đã được sao chép',
            please_enter_message: 'Vui lòng nhập tin nhắn',
            invalid_email: 'Email không hợp lệ',
            something_wrong_contact: 'Đã xảy ra lỗi. Vui lòng tải lại trang hoặc liên hệ với chúng tôi.',
            something_wrong: 'Đã xảy ra lỗi. Vui lòng tải lại trang.',
            sending: 'Đang gửi…',
            request_sent: 'Yêu cầu đã được gửi. Cảm ơn bạn!'
        }
    }
};

export const viMeta = {
    lang_origin: 'English',
    lang_eng: 'English',
    lang_code: 'vi',
};
